import { Shadows, Theme, createTheme as muiTheme } from '@mui/material/styles';

import { colorSchemes } from './color-schemes';
import { components } from './components/components';
import { shadows } from './shadows';
import { initializeTokens } from './tokens';

import type { Direction } from './types';

interface Config {
  primaryColor: string;
  direction?: Direction;
}

export function createTheme(config: Config): Theme {
  const tokens = initializeTokens(config.primaryColor);

  // const breakpoints = tokens.breakpoint;
  const tokenTypography = tokens.typographyStyles;

  const theme = muiTheme({
    breakpoints: {
      values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1440, max: 1680 },
    },

    typography: {
      // Pull this font stack from a token
      fontFamily:
        '"Roboto Flex", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
      h1: tokenTypography.h1,
      h2: tokenTypography.h2,
      h3: tokenTypography.h3,
      h4: tokenTypography.h4,
      h5: tokenTypography.h5,
      h6: tokenTypography.h6,
      body1: tokenTypography.body1,
      body2: tokenTypography.body2,
      button: tokenTypography.button,
      subtitle1: tokenTypography.subtitle1,
      subtitle2: tokenTypography.subtitle2,
      caption: tokenTypography.caption,
      overline: tokenTypography.overline,
    },

    colorSchemes: colorSchemes(tokens.palette),

    components,

    direction: config.direction,

    shadows: shadows as Shadows,

    shape: { borderRadius: 8 },

    cssVariables: {
      colorSchemeSelector: 'class',
    },

    tokens: tokens as any,
  });

  return theme;
}
